module.exports = __webpack_public_path__ + "static/media/sticky-note.95d443f3.svg";